import React, { Component } from 'react';
// import DinamisComponent from '../../component/DinamisComponent/DinamisComponent';
// import Product from '../ProductComponent/ProductComponent';
// import LifeCycleComp from '../LifeCycleComponent/LifeCycleComp.';
// import BlogPost from '../BlogPost/BlogPost';
import DisdukComponent from '../DisdukCapil/DisdukComponent';
// import CekNik from '../DisdukCapil/Ceknik/Ceknik';

class HomeComponent extends Component {
    state = {
        showComponent: true
    };
    componentDidMount() {
        // setTimeout(() => {
        //     this.setState({
        //         showComponent: false
        //     });
        // }, 5000)
    }
    render() {
        // console.log('asd');
        return (
            <div>
                {/* <DinamisComponent
                    nama='adse'
                    umur='2' />
                <DinamisComponent
                    nama='muchlis'
                    umur='3' />
                <DinamisComponent
                    nama='muchlisa'
                /> */}

                {/* <Product /> */}
                {/* <p>test LifeCycleComp</p>
                {this.state.showComponent ?
                    <LifeCycleComp />
                    : null
                } */}
                {/* <BlogPost /> */}
                <DisdukComponent />
            </div>
        )
    }
}

export default HomeComponent